import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { SystemLogoDataSchema } from '../../shared/logo.schema';
/**
 * Request Presigned URL Request Schema
 * POST /api/v2/upload-system-logo/request-url
 * Requests a presigned URL for direct upload to DigitalOcean Spaces
 */ export const SystemLogoRequestPresignedUrlRequestSchema = z.object({
    systemId: ObjectIdSchema
});
/**
 * Request Presigned URL Response Schema
 * Returns presigned POST URL and fields for direct upload
 */ export const SystemLogoRequestPresignedUrlResponseSchema = z.object({
    url: z.string(),
    fields: z.record(z.string(), z.string()),
    key: z.string(),
    expiresIn: z.number()
});
/**
 * Confirm Upload Request Schema
 * POST /api/v2/upload-system-logo/confirm
 * Confirms the upload and triggers processing
 */ export const SystemLogoConfirmUploadRequestSchema = z.object({
    systemId: ObjectIdSchema,
    key: z.string(),
    mimeType: z.string()
});
/**
 * Confirm Upload Response Schema
 * Returns processed system logo URLs (SVG or Raster)
 */ export const SystemLogoConfirmUploadResponseSchema = z.object({
    logo: SystemLogoDataSchema
});
/**
 * Upload System Logo Error Schema
 */ export const UploadSystemLogoErrorSchema = BaseErrorSchema;

//# sourceMappingURL=upload-system-logo.schema.js.map